/**
 * Firestore email flags for admin guest RSVP create/edit on the attendance list.
 * Keeps opt-in behaviour testable and aligned with sendRSVPConfirmation.
 */

export type GuestRsvpCreateEmailFlags = {
  sendGuestNotificationEmail?: true;
  skipEmail?: true;
  confirmationEmailSent?: true;
};

export type GuestRsvpEditEmailFlags = {
  sendGuestNotificationEmail?: true;
};

/** Flags written when adding a guest from the attendance list. */
export function buildGuestRsvpCreateEmailFlags(
  notifyGuestByEmail: boolean,
): GuestRsvpCreateEmailFlags {
  if (notifyGuestByEmail) {
    return { sendGuestNotificationEmail: true };
  }
  return { skipEmail: true, confirmationEmailSent: true };
}

/** Flags merged into an RSVP update when saving an edit from the attendance list. */
export function buildGuestRsvpEditEmailFlags(
  notifyGuestByEmail: boolean,
): GuestRsvpEditEmailFlags {
  if (notifyGuestByEmail) {
    return { sendGuestNotificationEmail: true };
  }
  return {};
}
